module.exports = __webpack_public_path__ + "img/tp_download_vc.60688879.svg";